export default __webpack_public_path__ + "static/media/bodyStars.6600085c.svg";